<template>
  <div>
    <FlexRow style="margin-bottom: 1rem;">
      <InputCheckbox label='Enabled' v-model="enabled"/>
    </FlexRow>
    <FlexRow>
      <FlexItem><InputTextField label='Analytics Address' :null2undefined="true" :help="apiDocs('clpp.BroadpeakConfiguration#analyticsAddress')" v-model="config.analyticsAddress"/></FlexItem>
      <FlexItem><InputTextField label='UUID' :null2undefined="true" :help="apiDocs('clpp.BroadpeakConfiguration#uuid')" v-model="config.uuid"/></FlexItem>
    </FlexRow>
    <FlexRow>
      <FlexItem><InputTextField label='Nano CDN Host' :null2undefined="true" :help="apiDocs('clpp.BroadpeakConfiguration#nanoCDNHost')" v-model="config.nanoCDNHost"/></FlexItem>
    </FlexRow>
    <FlexRow>
      <FlexItem><InputTextField label='Broadpeak Domain Names' :null2undefined="true" :help="apiDocs('clpp.BroadpeakConfiguration#broadpeakDomainNames')" v-model="config.broadpeakDomainNames"/></FlexItem>
    </FlexRow>
  </div>
</template>

<script>
import InputTextField from '../../forms/InputTextField';
import { Docs } from '../../../utils/docs';
import FlexRow from '../../layout/FlexRow';
import FlexItem from '../../layout/FlexItem';
import InputCheckbox from '../../forms/InputCheckbox';

export default {
  name: 'PlayerConfigBroadpeakConfig',
  components: { InputCheckbox, FlexItem, FlexRow, InputTextField },
  props: ['value'],
  data: function () {
    const broadpeakConfig = this.value.broadpeak || {};
    return {
      enabled: !!this.value.broadpeak,
      config: {
        analyticsAddress: broadpeakConfig.analyticsAddress,
        nanoCDNHost: broadpeakConfig.nanoCDNHost,
        broadpeakDomainNames: broadpeakConfig.broadpeakDomainNames,
        uuid: broadpeakConfig.uuid
      }
    };
  },
  updated () {
    this.value.broadpeak = this.enabled ? this.config : undefined;
  },
  methods: {
    apiDocs (field) {
      return Docs.getDescription(field);
    }
  }
};
</script>
